import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import CCTV from './pages/CCTV';
import AdminHome from './pages/AdminHome';
import * as serviceWorker from './serviceWorker';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";

/*,
    Link*/
import Login from "./pages/Login";

// ReactDOM.render(<CCTV/>, document.getElementById('root'));
ReactDOM.render(<Router>
    <div>
        {/*<ul>
            <li>
                <Link to="/">Home</Link>
            </li>
            <li>
                <Link to="/about">About</Link>
            </li>
            <li>
                <Link to="/dashboard">Dashboard</Link>
            </li>
        </ul>
        <hr />*/}

        {/*
          A <Switch> looks through all its children <Route>
          elements and renders the first one whose path
          matches the current URL. Use a <Switch> any time
          you have multiple routes, but you want only one
          of them to render at a time
        */}
        <Switch>
            <Route exact path="/cctv">
                <CCTV/>
            </Route>
            <Route exact path="/">
                <CCTV/>
            </Route>
            <Route path="/login">
                <Login/>
            </Route>
            <Route path="/admin/">
                <AdminHome/>
            </Route>
            <Route>
                <span>404 - Sayfa Bulunamadı</span>
            </Route>
        </Switch>
    </div>
</Router>, document.getElementById('root'));


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
